import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';
import { BasicObservable } from '@doxyme/extensions-bridge';
import { useBasicObservable } from './useBasicObservable';

/**
 * Addition to useBasicObservable {@link useBasicObservable}. Allows observable to be undefined
 * @param observable
 * @param defaultValue - default value to return when observable is undefined
 * @returns The current value of the observable and a setter function to update the value.
 */
export function useBasicObservableOptional<ObservableType>(
  defaultValue: ObservableType,
  observable?: BasicObservable<ObservableType>,
): [state: ObservableType, setState: Dispatch<SetStateAction<ObservableType>>] {
  const [localState, setLocalState] = useState<BasicObservable<ObservableType>>(
    observable ?? new BasicObservable(defaultValue),
  );

  useEffect(() => {
    setLocalState(observable ?? new BasicObservable(defaultValue));
  }, [observable]);

  const [state, setState] = useBasicObservable<ObservableType>(localState);

  return [state, setState];
}
